export default __webpack_public_path__ + "static/media/proccessing.701db33c.svg";